var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormatCodeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M8.218 8.11 4.33 11.996l3.889 3.89L6.804 17.3 1.5 11.998l5.303-5.303zm7.561 0 3.888 3.887-3.89 3.89 1.415 1.413 5.305-5.302-5.304-5.303zm-2.75-4.353 1.941.486-4 16-1.94-.486 4-16z"
}))));
export default SvgFormatCodeIcon;